import React from "react";
import SideBar from "../../components/Sidebar";
import PopularServices from "./PopularServices";
import MobileApp from "../../components/MobileApp";

const Home = () => {
  return (
    <div>
      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}

          <SideBar />

          {/* Main Content */}
          <div className="col-md-9 mb-3">
            {/* Popular Services */}
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Popular Services</h5>
                <div className="row text-center">
                  <PopularServices />
                </div>
              </div>
            </div>

            {/* Gift Cards */}
            {/* <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Top Gift Card</h5>
                <div className="row">
                  {[
                    { name: "Vijay Sales", discount: "2.00%" },
                    { name: "Croma", discount: "2.60%" },
                    { name: "@ Home", discount: "7.75%" },
                    { name: "Skullcandy", discount: "8%" },
                  ].map((gift, index) => (
                    <div className="col-6 col-lg-3 mb-3" key={index}>
                      <div className="border p-2 text-center rounded bg-light">
                        <div className="mb-2 fw-bold">{gift.name}</div>
                        <span className="badge bg-success">
                          {gift.discount} OFF
                        </span>
                      </div>
                    </div>
                  ))}
                  <div className="col-12 text-end">
                    <button className="btn btn-outline-primary btn-sm">
                      See All
                    </button>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* <MobileApp /> */}
    </div>
  );
};
export default Home;
